import React, { useEffect, useState, useMemo } from "react";
import "../sass/main.scss";
import dropdown_icon from "../static/images/icons/home_page_arrow.svg";
import landing_latest from "../static/images/landing/Wanderluxe_landing_latest.jpg";
import banner from "../static/images/logos/WL_Logo-02.svg";
import { Banner } from "../components/banner.js";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import { Image } from "../components/Image.js";
import LazyImage from "../components/LazyImage.js";

export default function Landing() {
  const [bannerFontSize, setBannerFontSize] = useState("1.8rem");
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width > 900 && width <= 1200) {
      setBannerFontSize("1.8rem");
      return;
    } else if (width > 600 && width <= 900) {
      setBannerFontSize("1.6rem");
      return;
    } else if (width <= 600) {
      setBannerFontSize("1.3rem");
      return;
    }

    return setBannerFontSize("1.8rem");
  }, [width]);

  const dragArrowSize = useMemo(() => {
    return width > 600 ? {
      height: 80,
      width: 80
    } : {
      height: 60,
      width: 70
    }
  }, [width]);

  const onClick = React.useCallback(() => {
    window.scrollTo({
      top: document.getElementById("drag-this-up").offsetTop + 100,
      behavior: "smooth",
    });
  }, []);
  return (
    <>
      <LazyImage component={
        <div className="header">
          <div
            className="header-part-2"
            style={{
              width: "100%",
              backgroundImage: `url(${landing_latest})`,
              backgroundSize: "cover",
            }}
          >
            <div className="header__text-box">
              <img src={banner} alt="" />
              <ul>
                <li>
                  <p>TRAVEL • CONNECT • DISCOVER</p>
                </li>

              </ul>
            </div>
          </div>

          <div
            id="drag-this-up"
            className="header__footer-img-container"
            style={{ cursor: "pointer" }}
            onClick={onClick}
          >
            <Image src={dropdown_icon} height={dragArrowSize.height} width={dragArrowSize.width} />
          </div>
        </div>
      } />

      <Banner
        style={{ marginTop: 0, borderTopLeftRadius: 0, borderTopRightRadius: 0, height: "20vh" }}
        width={width > 600 ? "60%" : "100%"}
        fontSize={bannerFontSize}
        renderIcons={false}
        backgroundColor={"#97789B"}
        headingStyle={{
          marginBottom: 0,
          padding: width < 600 && "1rem"
        }}
        heading={
          <>
            We are a passionate team of explorers, devoted to crafting unique and unforgettable experiences,{" "}
            tailor-made for women travelers.
          </>
        }
      />
    </>
  );
}
